// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
import { classNames } from '@progress/kendo-vue-common';
import { getItemValue } from './utils';
/**
 * Represents the default `ListDefaultItem` component.
 */

var ListDefaultItem = {
  name: 'list-default-item',
  props: {
    defaultItem: [Object, String],
    textField: String,
    selected: Boolean
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  methods: {
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();
    },
    onClick: function onClick(e) {
      this.$emit('defaultitemclick', e);
    }
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var _a = this.$props,
        selected = _a.selected,
        defaultItem = _a.defaultItem,
        textField = _a.textField;
    return h("div", {
      onClick: this.onClick,
      on: this.v3 ? undefined : {
        "click": this.onClick,
        "mousedown": this.onMouseDown
      },
      onMousedown: this.onMouseDown,
      "class": classNames('k-list-optionlabel', {
        'k-state-selected': selected
      })
    }, [getItemValue(defaultItem, textField) || '']);
  }
};
export { ListDefaultItem };


//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-dropdowns/dist/es/common/ListDefaultItem.js
// module id = 808
// module chunks = 93